import React from 'react'
import ToDoContainer from '../../../Components/Applications/ToDo'

export default function ToDo() {
  return (
    <div className='page-body'>
      <ToDoContainer />
    </div>
  )
}